export default __webpack_public_path__ + "static/media/YOIKER.c4a74f9e.png";